export const server = "https://www.timeplacebookapi.com";
export const user_store = "/api/user";
export const user_login = "/api/oauth/token";
export const post_create = "/api/post";
export const post_get_one = "/api/post";//is nesessary add {id} before this const
export const post_update_one = "/api/post/";//is nesessary add {id} before this const
export const post_delete_one = "/api/post/";//is nesessary add {id} before this const
export const post_get_All_by_user = "/api/user/";//is nesessary add /id/posts before this const
export const post_get_by_area = "/api/post/visibles";
export const post_get_by_area_and_days = "/api/post";//is necessary include params in path
export const post_get_post_list = "/api/post?";//is necessary include params in path


export const comment_store = "/api/comment";
export const comment_list = "/api/comment";
export const comment_show = "/api/comment/";//is nesessary add id (comment_id) after this const
export const comment_delete = "/api/comment/";//is nesessary add id (comment_id) after this const
export const comment_list_by_post = "/api/post/";//is nesessary add id/comments (post_id) after this const

export const km = 5;
export const days = 3;
export const logo = "assets/img/sinImagen.png";

export const client_id = "1";
export const client_secret = "4hEHEyPzuYYeQNhk1l7MEuwzPcHlpz9f2JN8jIj1";
export const grant_type = "password";



// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/nservices/index.path.ts